<template>
  <div id="app">
    <v-app>
      <v-navigation-drawer
        v-if="$store.getters.isAuthenticated && $vuetify.breakpoint.smAndDown"
        v-model="menuPhoneVisible"
        absolute
        temporary
        app
      >
        <v-list>
          <v-list-tile to="/home">
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile>

          <v-list-group
            prepend-icon="mdi-timetable"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.planning") }}</v-list-tile-title>
            </v-list-tile>

<!--
            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_schedule')"
              to="/schedule"
            >
              <v-list-tile-action>
                <v-icon>event</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.schedule", 1) }}</v-list-tile-title>
            </v-list-tile>
-->

            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_playlists')"
              to="/playlists"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>playlist_play</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.playlist", 2) }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasPermission('view_director_flags')"
              to="/mixing-console"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>movie</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.mixingConsole", 2) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            prepend-icon="palette"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.design") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_layouts')"
              to="/layouts"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>web</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.layout", 2) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            prepend-icon="devices"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $tc("app.device", 2) }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_boxes')"
              to="/boxes"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>storage</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.box", 2) }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_boxes')"
              to="/box-groups"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>folder</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.group", 2) }}</v-list-tile-title>
            </v-list-tile>

          </v-list-group>

          <v-list-group
            prepend-icon="video_library"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.library") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_media')"
              to="/media"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>perm_media</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.media") }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            prepend-icon="settings"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.management") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/settings">
              <v-list-tile-action>
                <v-icon>tune</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.setting", 2) }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasRole('organization_admin')"
              to="/organization-user-management"
            >
              <v-list-tile-action>
                <v-icon>group</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.userManagement", 2) }}</v-list-tile-title>
            </v-list-tile>

          </v-list-group>

          <v-list-group
            v-if="$store.getters.hasRole('superadmin')"
            prepend-icon="build"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.administration") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/user-management" sub-group>
              <v-list-tile-action>
                <v-icon>group</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.userManagement") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/organization-management" sub-group>
              <v-list-tile-action>
                <v-icon>domain</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.organizationManagement") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/box-management" sub-group>
              <v-list-tile-action>
                <v-icon>storage</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.boxManagement") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/news-editor" sub-group>
              <v-list-tile-action>
                <v-icon>mdi-newspaper</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.newsEditor") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/special-widgets" sub-group>
              <v-list-tile-action>
                <v-icon>widgets</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.specialWidget", 2) }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/update-management" sub-group>
              <v-list-tile-action>
                <v-icon>mdi_cellphone_arrow_down</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.updateManagement") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/developer" sub-group>
              <v-list-tile-action>
                <v-icon>mdi-console</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.developer") }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
      <v-navigation-drawer
        v-else-if="$store.getters.isAuthenticated && $vuetify.breakpoint.mdAndUp"
        v-model="menuDesktopVisible"
        :mini-variant.sync="mini"
        permanent
        fixed
        app
      >
        <v-list>
          <v-list-tile to="/home">
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ $t('general.home') }}</v-list-tile-title>
          </v-list-tile>

          <v-list-group
            prepend-icon="mdi-timetable"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.planning") }}</v-list-tile-title>
            </v-list-tile>

<!--
            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_schedule')"
              to="/schedule"
            >
              <v-list-tile-action>
                <v-icon>event</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.schedule", 1) }}</v-list-tile-title>
            </v-list-tile>
-->

            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_playlists')"
              to="/playlists"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>playlist_play</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.playlist", 2) }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasPermission('view_director_flags')"
              to="/mixing-console"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>movie</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.mixingConsole", 2) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            prepend-icon="palette"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.design") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_layouts')"
              to="/layouts"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>web</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.layout", 2) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            prepend-icon="devices"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $tc("app.device", 2) }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_boxes')"
              to="/boxes"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>storage</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.box", 2) }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_boxes')"
              to="/box-groups"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>folder</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.group", 2) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            prepend-icon="video_library"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.library") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasPermission('view_organization_media')"
              to="/media"
              sub-group
            >
              <v-list-tile-action>
                <v-icon>perm_media</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.media") }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            prepend-icon="settings"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.management") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/settings">
              <v-list-tile-action>
                <v-icon>tune</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.setting", 2) }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="$store.getters.hasRole('organization_admin')"
              to="/organization-user-management"
            >
              <v-list-tile-action>
                <v-icon>group</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.userManagement", 2) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            v-if="$store.getters.hasRole('superadmin')"
            prepend-icon="build"
            value="true"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ $t("app.administration") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/user-management" sub-group>
              <v-list-tile-action>
                <v-icon>group</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.userManagement") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/organization-management" sub-group>
              <v-list-tile-action>
                <v-icon>domain</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.organizationManagement") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/box-management" sub-group>
              <v-list-tile-action>
                <v-icon>storage</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.boxManagement") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/news-editor" sub-group>
              <v-list-tile-action>
                <v-icon>mdi-newspaper</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.newsEditor") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/special-widgets" sub-group>
              <v-list-tile-action>
                <v-icon>widgets</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $tc("app.specialWidget", 2) }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/update-management" sub-group>
              <v-list-tile-action>
                <v-icon>mdi-cellphone-arrow-down</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.updateManagement") }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/developer" sub-group>
              <v-list-tile-action>
                <v-icon>mdi-console</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t("app.developer") }}</v-list-tile-title>
            </v-list-tile>

          </v-list-group>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar
        v-if="$store.getters.isAuthenticated"
        color="primary"
        dark
        fixed
        app
      >
        <v-toolbar-side-icon
          v-if="$store.getters.isAuthenticated"
          class="hidden-md-and-up"
          @click.stop="togglePhoneMenu"
        ></v-toolbar-side-icon>
        <v-toolbar-side-icon
          v-if="$store.getters.isAuthenticated"
          class="hidden-sm-and-down"
          @click.stop="toggleDesktopMenu"
        ></v-toolbar-side-icon>
        <router-link
          to="/home"
          class="ml-3"
          style="height: 52px;"
        >
          <img
            height="52"
            src="@/assets/images/tarsius-next-logo-head-pink-52.png"
          />
        </router-link>
        <v-toolbar-title class="white--text">
          <span class="white--text">Tarsius</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu
          v-if="$store.getters.isAuthenticated"
          transition="slide-y-transition"
          offset-y
        >
          <v-btn
            slot="activator"
            flat
          >
            <v-icon left dark>person</v-icon>
              <span
                class="hidden-sm-and-down"
              >
                {{ $t('general.hiUser', [userProfile.name]) }}
              </span>
            <v-icon right dark>mdi-menu-down</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile to="/settings">
              <v-list-tile-content>
                {{ $t('general.language') }}
              </v-list-tile-content>
              <v-list-tile-avatar>
                <v-icon>language</v-icon>
              </v-list-tile-avatar>
            </v-list-tile>
            <v-list-tile @click="logout()">
              <v-list-tile-content>
                {{ $t('general.logout') }}
              </v-list-tile-content>
              <v-list-tile-avatar>
                <v-icon>lock</v-icon>
              </v-list-tile-avatar>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-content>
        <router-view></router-view>
      </v-content>
    </v-app>
  </div>
</template>

<style scoped>
</style>

<script>
import axios from 'axios';
import {
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_RESET_TOKENS,
} from '@/store/actions/auth';
import { USER_REQUEST } from '@/store/actions/user';

export default {
  name: 'App',
  computed: {
    userProfile() {
      return this.$store.state.user.profile;
    },
  },
  data: () => ({
    menuDesktopVisible: true,
    menuPhoneVisible: false,
    mini: true,
    retryCount: 0,
  }),
  created() {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const originalRequest = error.config;

        if (
          error.response.status === 401
          && !originalRequest.isRetryRequest
        ) {
          originalRequest.isRetryRequest = true;
          this.retryCount += 1;

          if (this.retryCount >= 3) {
            this.retryCount = 0;

            this.$store.commit(AUTH_ERROR, error);
            this.$store.dispatch(AUTH_RESET_TOKENS);
            this.$router.push('/');

            return Promise.reject(error);
          }

          return axios.post(`${window.api_url}api/login/refresh`, {
            refresh_token: localStorage.getItem('refresh-token'),
          }).then((resp) => {
            localStorage.setItem('access-token', resp.data.access_token);
            localStorage.setItem('refresh-token', resp.data.refresh_token);

            window.axios.defaults.headers.common.Authorization = `Bearer ${resp.data.access_token}`;
            originalRequest.headers.Authorization = `Bearer ${resp.data.access_token}`;

            this.$store.commit(AUTH_SUCCESS, resp);
            this.$store.dispatch(USER_REQUEST);

            return axios(originalRequest);
          });
        }

        return Promise.reject(error);
      },
    );

    this.$echo.private(`App.Models.User.${this.userProfile.id}`).listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', (notification) => {
      this.$toasted.show(
        notification.message,
        {
          duration: notification.duration,
          singleton: true,
          type: notification.status,
        },
      );
    });
  },
  methods: {
    togglePhoneMenu() {
      this.menuPhoneVisible = !this.menuPhoneVisible;
    },
    toggleDesktopMenu() {
      this.mini = !this.mini;
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT)
        .then(() => {
          this.$router.push('/');
        });
    },
  },
};
</script>

<style>

</style>
